module.exports = __webpack_public_path__ + "static/media/feature2ai.e916ddf6.png";